import React, { useEffect, useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";

import SweetAlert from "sweetalert2";

import api from "../../../services/api";

import ContentHeader from "../../../components/ContentHeader";
import Content from "../../../components/Content";
import CardHeader from "../../../components/CardHeader";
import TableGrid from "../../../components/TableGrid";
import CardFooter from "../../../components/CardFooter";

import {
  ajustaActiveClassMenu,
  searchByAllKeys,
  decrypt,
} from "../../../util/rotinas";
import { toast } from "react-toastify";
import Button from "../../../components/Button";

export default function Usuario() {
  const [loading, setLoading] = useState(false);
  const [listUsuarios, setListUsuarios] = useState([]);
  const [listUsuarioFiltrado, setListUsuarioFiltrado] = useState([]);

  const [btnNovoUsuario, setBtnNovoUsuario] = useState(false);
  const [btnEditarUsuario, setBtnEditarUsuario] = useState(false);
  const [btnExcluirUsuario, setBtnExcluirUsuario] = useState(false);

  const history = useHistory();
  const searchRef = useRef(null);

  async function getUsuarios() {
    setLoading(true);
    await api
      .get(`user`)
      .then((res) => {
        const temp =  res.data.data.filter(user => !user.is_api)
        setListUsuarios(temp);
        setListUsuarioFiltrado(temp);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    ajustaActiveClassMenu("conMenu", "usuMenu");

    const u = decrypt(localStorage.getItem("@ipm:user"), true);
    const acessos = u?.profile?.access;

    let aList;
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "user" &&
        a.action === "new" &&
        a.has_access
    );
    if (aList.length !== 0) setBtnNovoUsuario(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "user" &&
        a.action === "edit" &&
        a.has_access
    );
    if (aList.length !== 0) setBtnEditarUsuario(true);
    aList = acessos?.filter(
      (a) =>
        a.screen_name === "user" &&
        a.action === "delete" &&
        a.has_access
    );
    if (aList.length !== 0) setBtnExcluirUsuario(true);

    getUsuarios();
  }, []);

  const deleteUsuario = function (obj) {

    SweetAlert.fire({
      title: "Confirma exclusão do(a) usuário(a) ?",
      text: `${obj?.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .delete(`/user/${obj.id}`)
          .then(() => {
            toast.success(`Usuário excluído com sucesso.`, {
              position: "bottom-center",
              autoClose: true,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
            });
            getUsuarios();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });

  };

  const columns = useMemo(() => [

    {
      name: "Descrição",
      selector: "name",
      sortable: true,
      width: "400px",
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      width: "400px",
    },
    {
      name: "Perfil",
      selector: "profile.name",
      sortable: true,
      width: "400px",
    },
    {
      name: "Ativo",
      selector: "active",
      sortable: true,
      cell: (row) => <>{row.active ? "Sim" : "Não"}</>,
    },
    {
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">
          {btnEditarUsuario ? (
            <>
              <button
                className="btn btn-default btn-xs"
                onClick={() => history.push("/user/user-edit/" + row.id)}
              >
                <i className="fa fa-fw fa-pencil"></i>
              </button>
            </>
          ) : null}
          {btnExcluirUsuario ? (
            <>
              <button
                onClick={() => deleteUsuario(row)}
                className="btn btn-danger btn-xs"
              >
                <i className="fa fa-fw fa-trash-o"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Usuários"
      />
      <Content>
        <CardHeader
          title={"Usuários"}
          icon={"fa-users"}
          searchVisible={true}
          searchRef={searchRef}
          onChange={() =>
            setListUsuarioFiltrado(searchByAllKeys(listUsuarios, searchRef))
          }
        />
        <TableGrid
          columns={columns}
          data={listUsuarioFiltrado}
          loading={loading}
        />
        {btnNovoUsuario ? (
          <CardFooter >
            <Button
              type="button"
              title="Novo"
              onClick={() => history.push("/user/user-new")}
            />
          </CardFooter>
        ) : null}
      </Content>
    </>
  );
}
